





























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { IUser, UserRoles, IRoleItem } from "@/interfaces";
import { SetUserRoles, GetUserRoles } from "@/api";
import { RimRepairRolesComponent } from "@/components/common";
import { UserInterface } from "@/utils/UserInterface";

@Component({
  components: {
    RimRepairRolesComponent
  }
})
export default class UserRolesFormComponent extends Vue {
  @Prop({ required: true }) user!: IUser;
  @Prop({ required: true }) id!: number | null;
  public buttonLoading = false;
  public rolesLoading = true;
  public roles: UserRoles[] = [];
  private UI__: UserInterface;

  mounted() {
    this.UI__ = new UserInterface(this);
    this.getRoles();
  }

  async getRoles() {
    try {
      this.rolesLoading = true;
      const resp = await GetUserRoles(this.id!);
      this.rolesLoading = false;
      if (resp.Ok) {
        this.roles = resp.Roles;
      }
    } catch (err) {
      //
    }
  }

  async validate() {
    try {
      this.buttonLoading = true;
      const resp = await SetUserRoles(this.id!, this.roles);
      this.buttonLoading = false;
      if (resp.Ok) {
        this.$router.push("/users");

				this.UI__.RefreshTimestampUsers();

      }
    } catch (err) {
      //
    }
  }

  addRole(role: UserRoles) {
    this.roles.push(role);
  }

  removeRole(role: UserRoles) {
    this.roles = this.roles.filter(r => r !== role);
  }

  cancel() {
    this.$router.push("/users");
  }
}

